import { ISelectOption } from '~/src/dash/components/dropdowns/common';

/**
 * Helper to mask option labels for demo users
 * Assumes masking is needed - caller should check before calling
 */
export const maskOptionsForDemo = (
  options: ISelectOption[],
  demoPrefix: string,
): ISelectOption[] => {
  if (!options || options.length === 0) {
    return options || [];
  }
  return options.map((option) => ({
    ...option,
    label: `${demoPrefix}_${option.id}`,
  }));
};
